import MainLayout from "../components/common/MainLayout";
import MainForm from '../components/orders/MainForm'
const OrderDetail = () => {
    return (
        <MainLayout>
            <MainForm />
        </MainLayout>
    )
}

export default OrderDetail